import { TitleEntityForm } from '../../features/TitleEntityForm';
import { apiRequests } from '../../shared/api/apiRequests';

const EditProductCategoryPage = () => (
  <TitleEntityForm
    load={apiRequests.products.getCategory}
    update={apiRequests.products.updateCategory}
    backTo="/shop/products/categories"
    savedText="Категория сохранена"
  />
);

export default EditProductCategoryPage;
